/**
日历组件
带有日期跳转按钮
并附带有每一天的表格
但是每天的显示内容是未确定的，需要使用作用域插槽加入
插槽提供参数 date 
可以参考 LocationCalender.vue
 */

<template>
  <div>
    <!-- <h1>Calender</h1> -->
    <div class="calender-title">
      <div class="btn-group">
        <b-button variant="outline-primary" v-on:click="moveView(-1)">&lt;&lt;</b-button>
        <b-button variant="outline-primary" v-on:click="moveView(0,-1)">&lt;</b-button>
      </div>
      <h2 class="calender-title-content">{{viewDate.getFullYear()}} {{viewDate.getMonth()+1}}</h2>
      <div class="btn-group">
        <b-button variant="outline-primary" v-on:click="moveView(0,1)">&gt;</b-button>
        <b-button variant="outline-primary" v-on:click="moveView(1)">&gt;&gt;</b-button>
      </div>
    </div>
    <div class="calender-main">
      <div
        class="calender-head calender-col"
        v-for="(item, index) in calendarHead"
        :key="'head' + index"
      >{{$t('calender.'+item)}}</div>
      <div v-for="(week, index) in calendar" :key="index" class="calender-week">
        <div
          v-for="(day, index) in week"
          :key="index"
          class="calender-day calender-col"
          :class="dayStyle(day)"
        >
          <!-- <span class="calender-day-text">{{day.getMonth() + 1}} {{day.getDate()}}<span> -->
          <b>{{day.getMonth() + 1}}-{{day.getDate()}}</b>
          <br />
          <slot :date="day"></slot>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { newDate, diffDate } from "@/utils/day";
// 绘制日历，并带有批注
export default {
  data: function() {
    return {
      viewDate: new Date(),
      calendarHead: ["Su", "Mo", "Tu", "We", "Th", "Fr", "Sa"]
    };
  },
  computed: {
    /**
     * 获取每月数据
     */
    calendar: function() {
      let result = [];
      let viewDate = this.viewDate;
      const year = viewDate.getFullYear();
      const month = viewDate.getMonth() + 1;
      const firstDate = new Date(year, month - 1, 1);
      let offset = firstDate.getDay();

      const addDay = function(week, data) {
        if (!result[week]) {
          result[week] = [];
        }
        result[week].push(data);
      };

      // 本月
      let week = 0;

      // 共需要绘制的日期数
      // A 方案，动态计算本月的天数
      // const lastDate = new Date(year, month, 0);
      // const dayNum = diffDate(lastDate, firstDate) + offset + 7 - lastDate.getDay();
      // B 方案，固定绘制 42 天（和 win10 的日历是一致的）
      const dayNum = 6 * 7;

      let current = newDate(firstDate, -offset);
      for (let i = 0; i < dayNum; i++) {
        addDay(week, current);
        if (current.getDay() === 6) {
          week += 1;
        }
        current = newDate(current, 1); // 第二天
      }

      return result;
    }
  },
  methods: {
    moveView(y = 0, m = 0, d = 0) {
      let now = this.viewDate;
      this.viewDate = new Date(
        now.getFullYear() + y,
        now.getMonth() + m,
        now.getDate() + d
      );
    },
    dayStyle(item) {
      const viewDate = this.viewDate;
      const day = item.getDay();
      const month = item.getMonth();
      return {
        "in-this-month": month === viewDate.getMonth(),
        weekend: [0, 6].includes(day),
        today: diffDate(item, new Date()) === 0, // 判断是否是今天
      };
    }
  },
  props: ["plan"]
};
</script>

<style scope>
.calender-title {
  justify-content: center;
  display: flex;
  margin: 3% 1% 1% 1%;
}
.calender-title-content {
  display: inline;
  margin: 0 5%;
}
.calender-week {
  width: 100%;
  overflow: hidden;
  display: flex;
}

.calender-day {
  background-color: white;
  color: darkgray;
  min-height: 8rem;
  align-items: stretch;
  border-top: 1px solid #000;
  border-bottom: 1px solid #000;
  border-left: 1px;
  border-right: 1px;
  overflow: hidden;
  padding: 10px;
}

/* .calender-day-text{
  font-size: 1.5rem
} */

.calender-col {
  width: 14%;
  float: left;
  /* margin: 0.1%; */
}

.calender-head {
  /* height: 2rem; */
  /* border: 1px solid; */
  background-color: #0099c4;
  color: #ffffff;
  text-align: center;
  font-size: 1.5rem;
}

.calender-main {
  margin: 0 2%;
}

.in-this-month {
  color: black;
  /* background-color: aqua; */
}

.weekend {
  background-color: #f2f2f2;
}

.weekend.in-this-month {
  color: #0099c4;
}

.today {
  /* 为今天绘制边框 */
  border:#fb0 solid;
}
</style>